import type { ReactElement } from 'react';
import { Outlet } from 'react-router';

import { AccountGate } from '@/components/auth/AccountGate';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { ToastProvider } from '@/components/ui/toast';
import { ActiveCompanyProvider } from '@/lib/active-company-provider';
import { useActiveCompany } from '@/lib/active-company-context';

import { Header } from './Header';
import { OfflineBanner } from './OfflineBanner';
import { PageChromeProvider } from './page-chrome';
import { Ribbon } from './Ribbon';
import { Sidebar } from './Sidebar';

function Shell(): ReactElement {
  const { slug } = useActiveCompany();
  return (
    <div className="shell" {...(slug ? { 'data-empresa': slug } : {})}>
      <Sidebar />
      <main className="main" tabIndex={-1}>
        <OfflineBanner />
        <Ribbon />
        <Header />
        <div className="content">
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </div>
      </main>
    </div>
  );
}

export function AppShell(): ReactElement {
  return (
    <ActiveCompanyProvider>
      <PageChromeProvider>
        <ToastProvider>
          <AccountGate>
            <Shell />
          </AccountGate>
        </ToastProvider>
      </PageChromeProvider>
    </ActiveCompanyProvider>
  );
}
